import { Component, Prop, Vue } from 'vue-property-decorator';
import { SdTextarea, SdButton, SdSlideOver } from '@/Components';
import { ClientInfo, Process } from '@/Domain/Entities';
import { mapState } from 'vuex';
import MasterDataService from '@/Services/MasterDataService';
import LinkedinService from '@/Services/LinkedinService';
import LinkedInPostDto from '@/Domain/Entities/LinkedInPostDto';
import {ToasterService} from '@/Services/ToasterService';

@Component({
    name: 'linked-in-post',
    components: {
        SdTextarea,
        SdButton,
        SdSlideOver
    },
    computed: {
        ...mapState('languagesStore', { currentLanguage: 'current' })
    }
})

export default class LinkedInPost extends Vue {
    @Prop() processSelected!: Process;
    @Prop() linkedInOrganizationId!: string;
    
    code: string = '';
    currentLanguage!: string;
    clientInfo: ClientInfo = new ClientInfo({});
    postText: string = '';
    submitted: boolean = false;
    isLoading: boolean = false;
    showLinkedInModalSuccess: boolean = false;

    $refs!: {
        slideOver: SdSlideOver;
    };
    
    get linkedInPostUrl() {
        return `https://www.linkedin.com/company/${this.linkedInOrganizationId}/admin/dashboard/`;
    }

    getApplicantProcessUrl() {
        return `${this.clientInfo.getHost()}/processDetail.html?id=${this.processSelected.id}&type=${this.processSelected.type}`;
    }

    closeSlideOver() {
        this.$emit('closeSlideOver');
        this.$refs.slideOver.setOverflowAutoToBody();
    }

    postSuccessfuly(success: boolean) {
        if (!success) { return; } 
            
        console.log('entro aweonao');
        this.showLinkedInModalSuccess = true;
    }

    onClinkAcceptSuccessful() {
        this.showLinkedInModalSuccess = true;
        this.closeSlideOver();
    }

    addMoreInfoText() {
        const urlString = `\n${this.$i18n.t('lang.linkedin.moreInfo', { processTitle: this.processSelected.title.getValue(this.currentLanguage), url: this.getApplicantProcessUrl() })}`;

        this.postText += urlString;
    }

    handlePublishOnLinkedin() {
        this.submitted = true;
        if (this.submitted && !this.postText || this.postText.length === 0) { return; }

        this.callLinkedInAuth();
    }

    async postInLinkedIn() {
        let response;
        try {
            this.addMoreInfoText();

            response = await LinkedinService.exchangeCallback(new LinkedInPostDto({
                code: this.code,
                postText: this.postText,
                entityOepId: this.processSelected.entityOepId,
                processId: this.processSelected.id
            }));

            this.postSuccessfuly(response.success);
        } catch (err) {
            if (err === 422) { ToasterService.showError(this.$i18n.t('lang.linkedin.duplicatePost') as string); }
            console.log(err);
        }
    }

    createLinkedinPopUp(url: string) {
        const width = 600;
        const height = 700;
        const left = window.screenX + 20;
        const top = window.screenY + (window.innerHeight - height) / 2;
        const popup = window.open(
            url,
            'LinkedInOAuth',
            `width=${width},height=${height},left=${left},top=${top}`
        );
        if (!popup) {
            throw new Error(this.$i18n.t('lang.linkedin.popUpBlocked') as string);
        }
        return popup;
    }

    async callLinkedInAuth(): Promise<void> {
        try {
            const { authUrl } = await LinkedinService.getLinkedinAuthorizationEndpoint();
            const popup = this.createLinkedinPopUp(authUrl);
            await this.handlePopupMessage(popup);
        } catch (err) {
            ToasterService.showError(this.$i18n.t('lang.linkedin.authError') as string);
            console.error('Error en OAuth:', err);
        }
    }

    async handlePopupMessage(popup: Window) {
        await new Promise<void>((resolve, reject) => {
            
            const handleMessage = async (event: MessageEvent) => {
                if (event.origin !== window.location.origin) { return; }

                const data = event.data ? event.data : {};
                const { code, error } = data;

                if (!code && !error) { return; }

                window.removeEventListener('message', handleMessage);
                clearInterval(checkPopupClosed);

                if (error) { reject(new Error(error)); }
                this.code = code;
                
                if (!popup.closed) { popup.close(); }
                
                await this.postInLinkedIn();
            };
            window.addEventListener('message', handleMessage);

            // Cierre manual
            const checkPopupClosed = setInterval(() => {
                if (popup.closed) {
                    clearInterval(checkPopupClosed);
                    window.removeEventListener('message', handleMessage);
                    reject(new Error(this.$i18n.t('lang.linkedin.popUpCloseManuallyError') as string));
                }
            }, 500);
        });
    }

    initClientInfo() {
        MasterDataService.getClientInfo()
            .then(responseMasterData => {
                this.clientInfo = new ClientInfo(responseMasterData);
            })
            .catch(error => console.log(error));
    }

    mounted() {
        this.initClientInfo();
    }
}
